<template>
  <v-app>
    <v-navigation-drawer
      fixed clipped
      v-if="showToolbar"
      v-model="drawer" app>
      <v-list>
        <v-subheader>My Cases</v-subheader>
        <v-list-item-group color="primary">
          <v-list-item v-for="aCase in cases" :key="aCase.caseId">
            <v-list-item-icon>
              <v-icon>mdi-notebook</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              <span @click="openCase(aCase.caseId)">{{aCase.caseId}} - {{ aCase.name }}</span>
              <!-- <router-link :to="'/case/' + aCase.caseId">
                <span @click="">{{aCase.caseId}} - {{ aCase.name }}</span>
              </router-link> -->
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      v-if="showToolbar"
      color="primary"
      fixed clipped-left app>
      <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->
      <v-app-bar-nav-icon class="white--text" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="white--text">PBLMed</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="navigate('home')" class="mr-8">
      <!-- <v-btn icon large to="/home" class="mr-8"> -->
        <v-icon class="white--text">home</v-icon>
      </v-btn>
      <v-btn v-if="isAdmin" icon @click="navigate('users')" class="mr-8">
        <v-icon class="white--text">mdi-wrench</v-icon>
      </v-btn>
      <v-menu open-on-hover bottom offset-y class="mr-4">
        <template v-slot:activator="{on}">
          <v-btn
            color="primary"
            v-on="on"
            large
            icon>
            <v-avatar size="24">
              <img src="/static/avatar_placeholder.png">
            </v-avatar>
            <v-icon class="white--text">arrow_drop_down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="navigate('profile')">
            <v-list-item-icon>
              <v-icon>person</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Profile</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon>list</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              <a target="_blank" style="text-decoration: none;" href="/static/files/instructions/queries.pdf">
                Queries
              </a>
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="navigate('feedback')">
            <v-list-item-icon>
              <v-icon>comment</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Feedback</v-list-item-title>
          </v-list-item>
          <v-list-item @click="navSignOut()">
            <v-list-item-icon>
              <v-icon>logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Sign Out</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-main>
      <router-view></router-view>
    </v-main>
    <v-overlay :value="loading">
      <v-progress-circular
      indeterminate
      size="64" />
    </v-overlay>
    <v-footer v-if="showToolbar" fixed app>
      <v-layout column align-center justify-center>
        <div class="ml-3">
          <span>&copy; 2018 - 2023 All rights reserved</span>
        </div>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
import router from '../routes'
import { mapGetters } from 'vuex'

export default {
  props: {
    sidebar: Boolean,
    path: String
  },
  data: () => {
    return {
      username: '',
      drawer: this.sidebar
    }
  },
  computed: {
    ...mapGetters({
      loading: 'getLoading',
      cases: 'allCases',
      email: 'getUsername',
      admins: 'getAdmins',
      showToolbar: 'getShowToolbar'
    }),
    isAdmin: function () {
      return this.admins.includes(this.email)
    }
  },
  watch: {
    email () {
      // console.log('username: ' + this.email)
      var str = this.email
      var index = str.indexOf('@')
      this.username = str.substring(0, index)
    },
    $route (to, from) {
      this.updateSideBar(to.path)
    }
  },
  methods: {
    navSignOut: function () {
      // console.log(this.$route)
      this.$store.dispatch('signOut')
      if (this.$route.path !== '/') {
        router.push('/', () => {})
      }
    },
    navigate: function (path) {
      if (this.$route.path !== '/' + path) {
        router.push('/' + path)
      }
    },
    openCase (cid) {
      this.$store.dispatch('setCaseId', cid)
      this.navigate('case/' + cid)
    },
    updateSideBar (path) {
      // console.log('window.width: ' + window.innerWidth)
      if (window.innerWidth >= 960) {
        this.drawer = path.includes('dash') || false
      } else {
        this.drawer = false
      }
    }
  },
  created: function () {
    this.updateSideBar(this.path)
  }
}
</script>
<style scoped>
/* * {
  font-family: 'Alegreya', serif;
} */
.maincontent {
  border: 1px solid red;
}
a {
  text-decoration: none;
}
a:hover {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout.vue